"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.Dotted = exports.Manuever = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Manuever = _styledComponents["default"].div.withConfig({
  displayName: "style__Manuever",
  componentId: "sc-15yxilz-0"
})(["display:flex;height:50px;align-items:center;width:100%;"]);

exports.Manuever = Manuever;

var Dotted = _styledComponents["default"].div.withConfig({
  displayName: "style__Dotted",
  componentId: "sc-15yxilz-1"
})(["width:90%;display:flex;flex-direction:column;& > div{height:auto;border-bottom:2px dotted white;}"]);

exports.Dotted = Dotted;

var Icon = _styledComponents["default"].div.withConfig({
  displayName: "style__Icon",
  componentId: "sc-15yxilz-2"
})(["color:white;width:5%;display:flex;"]);

exports.Icon = Icon;